import React, { useEffect, useState } from "react";
import logout from "../assets/logout.png";
import { Link } from "react-router-dom";
import trashicon from "../assets/trash.png"; // أيقونة سلة لازم تكون عندك في assets
import editnumber from "../assets/pen-number.png";

const UpdateData = () => {
  const isGust = localStorage.getItem("role") === "gust";

  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    email: "",
    password: "",
    image: null,
  });

  const token = localStorage.getItem("token"); // ✅ جلب التوكن

  // Fetch users
  useEffect(() => {
    fetch("http://backend.goldensection.agency/public/api/getuser", {
      headers: {
        Authorization: `Bearer ${token}`, // ✅ إضافة التوكن
      },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data.users || []))
      .catch((err) => console.error(err));
  }, [token]);

  // Handle delete
  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من الحذف؟")) return;

    await fetch(
      `http://backend.goldensection.agency/public/api/deleteuser/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`, // ✅ إضافة التوكن
        },
      },
    );

    setUsers(users.filter((u) => u.id !== id));
  };

  // Handle edit open
  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      name: user.name,
      brand: user.brand,
      email: user.email,
      password: "",
      image: null,
    });
  };

  // Handle save edit
  const handleSave = async () => {
    const form = new FormData();
    form.append("name", formData.name);
    form.append("brand", formData.brand);
    form.append("email", formData.email);
    if (formData.password) form.append("password", formData.password);
    if (formData.image) form.append("image", formData.image);

    await fetch(
      `http://backend.goldensection.agency/public/api/adminupdateinfouser/${editingUser.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // ✅ إضافة التوكن
        },
        body: form,
      },
    );

    setUsers(
      users.map((u) => (u.id === editingUser.id ? { ...u, ...formData } : u)),
    );
    setEditingUser(null);
  };

  return (
    <div>
      <div className="navbar_admin">
        <h2>لوحة التحكم في حسابات العملاء</h2>
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
      </div>

      <div className="admin_area">
        <table className="users-table">
          <thead>
            <tr>
              <th>الصورة</th>
              <th>الاسم</th>
              <th>البراند</th>
              <th>الايميل</th>
              {!isGust && <th>التحكم</th>}
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>
                  {u.image ? (
                    <img
                      src={`http://backend.goldensection.agency/public/api/${u.image}`}
                      alt={u.name}
                      className="user-img"
                    />
                  ) : (
                    "لا توجد صورة"
                  )}
                </td>
                <td>{u.name}</td>
                <td>{u.brand}</td>
                <td>{u.email}</td>
                {!isGust && (
                  <td>
                    <button className="edit-btn" onClick={() => handleEdit(u)}>
                      <img src={editnumber} alt="edit" />
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(u.id)}
                    >
                      <img src={trashicon} alt="delete" />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editingUser && (
        <div className="popup-overlay">
          <div className="popup">
            <h3>تعديل بيانات المستخدم</h3>
            <label>اسم العميل</label>
            <input
              type="text"
              placeholder="الاسم"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
            <label>اسم البراند</label>

            <input
              type="text"
              placeholder="البراند"
              value={formData.brand}
              onChange={(e) =>
                setFormData({ ...formData, brand: e.target.value })
              }
            />
            <label>الايميل</label>

            <input
              type="email"
              placeholder="الايميل"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
            <label>كلمة السر</label>

            <input
              type="password"
              placeholder="كلمة السر الجديدة (اختياري)"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
            <label> اللوجو</label>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setFormData({ ...formData, image: e.target.files[0] })
              }
            />
            <div className="popup-actions">
              <button className="save-btn" onClick={handleSave}>
                حفظ
              </button>
              <button
                className="cancel-btn"
                onClick={() => setEditingUser(null)}
              >
                X
              </button>
              {/* <button  classname="close-btn" fdprocessedid="n0upae" >X</button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateData;
